import { ActionContext, GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import { RootState } from '@/store/types';
import vuei18n from '@/i18n/index';
import { Locale } from './types';

const defaultLocale: Locale | null = ((): Locale | null => {
  //return 'vi'; // memo: 動作確認の際に特定の言語から始めたい場合はココのコメントを外すと便利だよ

  const language = (
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language
  ).toLowerCase();

  if (['en', 'en-au', 'en-ca', 'en-gb', 'en-us'].includes(language)) {
    return 'en';
  }

  if (['ja', 'ja-jp'].includes(language)) {
    return 'ja';
  }

  if (['vi', 'vi-vn'].includes(language)) {
    return 'vi';
  }

  if (['id', 'id-id'].includes(language)) {
    return 'id';
  }

  return null;
})();

export interface LocalesDictionary {
  [index: string]: string;
}

export type LocaleState = {
  locale: Locale;
};

function createState(): LocaleState {
  const state: LocaleState = {} as LocaleState;
  clearState(state);
  return state;
}

function clearState(state: LocaleState): void {
  state.locale = '';
}

export const getters: GetterTree<LocaleState, RootState> = {
  locale: (state: LocaleState): Locale => {
    return state.locale;
  }
};

export const mutations: MutationTree<LocaleState> = {
  setLocale(state: LocaleState, payload: LocaleState) {
    state.locale = payload.locale;
  },

  clearState(state: LocaleState) {
    clearState(state);
  }
};

export const actions: ActionTree<LocaleState, RootState> = {
  clearState(context: ActionContext<LocaleState, RootState>): void {
    context.commit('clearState');
  },

  setDefaultLocale(context: ActionContext<LocaleState, RootState>) {
    const locale: Locale = context.getters.locale || defaultLocale || 'en';
    context.commit('setLocale', { locale });
    vuei18n.locale = locale;
  },

  setLocaleWithi18n(context: ActionContext<LocaleState, RootState>, payload: LocaleState) {
    context.commit('setLocale', payload);
    vuei18n.locale = payload.locale;
  },

  setLocaleWithi18nWithoutDefaultLocale(context: ActionContext<LocaleState, RootState>, payload: LocaleState) {
    if (defaultLocale !== null) return;
    context.dispatch('setLocaleWithi18n', payload);
  }
};

export const i18n: Module<LocaleState, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
